import _                                        from 'underscore';
import React, { FC }                            from 'react';
import { useQuery }                             from '@apollo/react-hooks';
import { DecisionEngineQueries }                from '../../../../queries';
import { formatOption }                         from '../../../../util';
import { QueriedSelectFieldProps, SelectField } from '../../../components/forms';
import { INTAKE_QUESTION_CONTEXT_INFO }         from '../../../../constants/ProductEnums';
import { LangService }                          from '../../../../services';

const QueryDropdown: FC<QueriedSelectFieldProps> = ( props ) => {
	
	let { data, loading, error } = useQuery( DecisionEngineQueries.queries.GET_INTAKE_QUESTIONS( `id name ordinal questionContext` ), { fetchPolicy: 'cache-and-network' } );
	
	let isLoading = ( props.loading || loading );
	
	let options = ( data )
	              ? _.sortBy( data.intakeQuestions, 'ordinal' )
	                 .map( ( { id, name, questionContext } ) =>
		                 formatOption( id, name, {
			                 group: LangService.getTermFromDictionary( INTAKE_QUESTION_CONTEXT_INFO[ questionContext ].LABEL )
		                 } )
	                 )
	              : [];
	return (
		<SelectField
			{ ...props }
			loading={ isLoading }
			options={ options }>
		</SelectField>
	);
};

QueryDropdown.defaultProps = {
	loading: false,
};

export { QueryDropdown as IntakeQuestionDropdown };
